module.exports = __webpack_public_path__ + "img/avatar-s-20.32972323.jpg";